import React, { useEffect, useState } from 'react';
import {
    FixedDepositsHero,
    FixedDepositsBenefits,
    FixedDepositsCarousel,
    FDReturnsCalculator,
    FDBookingSteps,
    FDInterestRateComparison,
    FDFaqs,
} from '@components/Products/FixedDeposits/components';
import { FooterV2 } from '@molecules/index';
import DownloadAppQrCode from '@molecules/Footer/V2/DownloadAppQrCode';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { fdProductEvents } from '@helpers/enums/gaEventNameEnum';
import { appFdQrCode } from '@helpers/constants';

const FixedDeposits = ({ fixedDepositBanks, fdCompareContent, maxInterest }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const onDownloadClick = ({ show, isIos }) => {
        setIsModalOpen(show);
    };

    useEffect(() => {
        triggerCustomEvent(fdProductEvents.VIEWED_FD_PRODUCT_PAGE);
    }, []);

    return (
        <main className="flex flex-col w-full mx-auto overflow-hidden bg-basicWhite">
            <FixedDepositsHero toggleModal={toggleModal} maxInterest={maxInterest} />
            <FixedDepositsBenefits />
            <FixedDepositsCarousel
                fixedDepositBanks={fixedDepositBanks}
                toggleModal={toggleModal}
            />
            <FDReturnsCalculator toggleModal={toggleModal} />
            <FDBookingSteps toggleModal={toggleModal} />
            <FDInterestRateComparison fdCompareContent={fdCompareContent} />
            <FDFaqs />
            <FooterV2 isLightFooter={true} />
            {isModalOpen && (
                <DownloadAppQrCode
                    show={isModalOpen}
                    isIos
                    onClose={() =>
                        onDownloadClick({
                            qrImage: null,
                            isIos: null,
                        })
                    }
                    qrCode={appFdQrCode}
                    hideTitle
                />
            )}
        </main>
    );
};

export default FixedDeposits;
